export default __webpack_public_path__ + "static/media/ua.f3df95ac.svg";